var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.modules.regular)?_c('Modals'):_vm._e(),(_vm.modules.user)?_c('UserModals'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }